import { Box, IconButton } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import React from 'react'
import CustomHeading from './CustomHeading'

export default function HeadingWithCloseIcon({ handleClose, heading }) {
  return (
    <Box display="flex" justifyContent="space-between">
      <CustomHeading heading={heading} />
      <IconButton color="inherit" onClick={handleClose} style={{ position: 'relative', top: '-17px', left: '18px' }}>
        <Close />
      </IconButton>
    </Box>
  )
}
